import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DisplayGuiaSeg {
	display: boolean;
	path: {
		rutaKey: string;
		cursoKey: string;
		tipoKey: string;
		tipoActividad: 'grupal' | 'individual';
		numeroSesion: number;
		numeroRutaSesion: number;
		isVistaTablaEquipo: boolean;
		grupoKey: string | undefined;
		rutaSesionComentarioKey?: string;
		tipoView?: 'guia' | 'coevaluacion' | 'autoevaluacion';
		rutaSesionKey?: string;
	} | null;
}

const initialState: DisplayGuiaSeg = {
	display: false,
	path: null
};

const displayGuiaSegSlice = createSlice({
	name: 'displayGuiaSegSlice',
	initialState,
	reducers: {
		setDisplayGuiaSeg: (state, action: PayloadAction<DisplayGuiaSeg>) => {
			return action.payload;
		},
		updatePositionDisplayGuiaSeg: (state, action) => {
			if (!state.path) return state;
			const { numSesion, tipoView, rutaSesionKey } = action.payload;
			return {
				...state,
				display: true,
				path: {
					...state.path,
					numeroSesion: numSesion,
					tipoView,
					rutaSesionKey
				}
			};
		},
		updateStudentDisplayGuiaSeg: (state, action) => {
			if (!state.path) return state;
			const { estudianteKey: newKey, grupoKey: newGrupoKey } = action.payload;

			return {
				...state,
				display: true,
				path: {
					...state.path,
					tipoKey: newKey,
					grupoKey: newGrupoKey
				}
			};
		},
		resetDisplayGuiaSeg: () => {
			return initialState;
		}
	}
});

export const { setDisplayGuiaSeg, updatePositionDisplayGuiaSeg, updateStudentDisplayGuiaSeg, resetDisplayGuiaSeg } =
	displayGuiaSegSlice.actions;

export default displayGuiaSegSlice.reducer;
